<template>
  <vuestic-navbar>
    <header-selector slot="selector" :isOpen.sync="valueProxy" />
    <span slot="logo">
      <img
        :src="require('@/assets/images/header-logo.png')"
        class="navbar-logo d-none d-md-block"
        alt="Innocalls"
      />
    </span>
    <profile-dropdown class="nav-item">
      <template slot="avatar">
        <img
          src="https://www.plaxis.com/content/uploads/2016/08/dummy-user-300x300.png"
          alt="Profile"
        />
      </template>
    </profile-dropdown>
    <div class="navbar-logout" @click="logout">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 17.99 17.99"
        width="17.99"
        height="17.99"
      >
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <path
              class="cls-1"
              d="M18,9A9,9,0,1,1,9,0,9,9,0,0,1,18,9ZM9,17.07A8.08,8.08,0,1,0,.92,8.89,8.07,8.07,0,0,0,9,17.07Z"
            />
            <path
              class="cls-1"
              d="M14.1,9A5.1,5.1,0,1,1,6.39,4.61a.47.47,0,0,1,.66.11.45.45,0,0,1-.2.66A4.13,4.13,0,0,0,4.93,8a4.19,4.19,0,1,0,6.21-2.59.47.47,0,0,1-.26-.47.44.44,0,0,1,.35-.39.47.47,0,0,1,.35.07A5.09,5.09,0,0,1,14,8.16a4.88,4.88,0,0,1,.06.52C14.1,8.78,14.1,8.89,14.1,9Z"
            />
            <path
              class="cls-1"
              d="M9.45,5.14c0,.5,0,1,0,1.51a.45.45,0,0,1-.64.43.43.43,0,0,1-.27-.41V3.57a.46.46,0,1,1,.91,0C9.46,4.11,9.45,4.62,9.45,5.14Z"
            />
          </g>
        </g>
      </svg>
      <span class="navbar-logout-title">
        {{ $t('user.logout') }}
      </span>
    </div>
    <language-toggle class="nav-item" />
  </vuestic-navbar>
</template>

<script>
import VuesticIconVuestic from '../../../vuestic-theme/vuestic-components/vuestic-icon/VuesticIconVuestic'
import VuesticNavbar from '../../../vuestic-theme/vuestic-components/vuestic-navbar/VuesticNavbar'
import HeaderSelector from './components/HeaderSelector'

import LanguageToggle from './components/dropdowns/LanguageToggle'
import ProfileDropdown from './components/dropdowns/ProfileDropdown'
import NotificationDropdown from './components/dropdowns/NotificationDropdown'
import MessageDropdown from './components/dropdowns/MessageDropdown'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'app-navbar',
  components: {
    VuesticNavbar,
    HeaderSelector,
    LanguageToggle,
    ProfileDropdown
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      user: ''
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'tenantID']),
    valueProxy: {
      get() {
        return this.isOpen
      },
      set(opened) {
        this.$emit('toggle-menu', opened)
      }
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
    }
  }
}
</script>
<style lang="scss">
.navbar-brand,
.navbar-brand .navbar-logo {
  height: 90%;
  @media (max-width: 900px) {
    height: auto;
    width: 300px;
    margin-top: 12px;
  }
}
.nav-item {
  margin: 0 1rem;
  @media (max-width: 768px) {
    margin: 0 0;
  }
}
.nav-username {
  font-weight: 500;
  color: $white;
  text-transform: uppercase;
}
.navbar-logout {
  display: flex;
  align-items: center;
  color: $white;
  margin: 0 5px;
  transition: color 0.1s ease-in;
  svg {
    margin-right: 10px;
    fill: $darkblue;
    transition: fill 0.1s ease-in;
    @media (max-width: 768px) {
      margin-right: 4px;
    }
  }
  &:hover {
    cursor: pointer;
    color: lighten($blue, 10%);
    svg {
      fill: lighten($blue, 10%);
    }
  }
}
@media (max-width: 575px) {
  .navbar-logo {
    display: none;
  }
}
</style>
